import React, { useContext, useEffect, useState } from 'react';
import DataSettings from './data-settings';
import Heading from '../../components/shared/heading';
import { getAccounts } from '../../services/auth-service';
import Loader from '../../components/shared/loader';
import { getAllUnits } from '../../services/preferences-service';
import { AccountsContext } from '../../components/context/account-context';
import Help from './help';
import { usePageHelp } from '../../components/context/help-context';
import Modal from '../../components/shared/modal';
import AuditLogModal from '../../components/shared/AuditLogModal';
import auditicon from '../../assets/images/audit-icon.png';

const Preferences = () => {
    usePageHelp(Help);
    const { accountId, setAttributes } = useContext(AccountsContext);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [units, setUnits] = useState([]);
    const [error, setError] = useState(null);
    const [isAuditLogModalOpen, setIsAuditLogModalOpen] = useState(false);

    const fetchPreferences = async () => {
        setLoading(true);
        try {
            // Fetch both in parallel
            const [accountRes, unitRes] = await Promise.all([
                getAccounts(),
                getAllUnits(accountId)
            ]);

            console.log(accountRes)

            // Handle accounts response
            if (accountRes.success) {
                setAccounts(accountRes.data.data || []);
            } else {
                throw new Error(accountRes.data?.message || 'Failed to fetch business accounts');
            }

            // Handle units response
            if (unitRes.success) {
                setUnits(unitRes.data.data || []);
            } else {
                throw new Error(unitRes.data?.message || 'Failed to fetch units');
            }

            setError(null);
        } catch (err) {
            setError(err.message || 'An error occurred while fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (accountId) {
            fetchPreferences();
        }
    }, [accountId]);

    return (
        <div className="py-4">
            <div className="pb-3 px-6 border-b flex items-center justify-between">
                <div>
                    <Heading>Preferences</Heading>
                    <p className="text-gray-700">Adjust kind of settings you want.</p>
                </div>
                <button
                    className={`bg-gray-100 text-black border-gray-400 px-3 !py-1.5 !text-sm rounded-lg hover:scale-105 duration-300 transition-all`}
                    onClick={() => setIsAuditLogModalOpen(true)}>
                    <img src={auditicon} className='w-6 h-6 object-contain' alt="audit icon" />
                </button>
            </div>

            <div className="px-6">
                {error && (
                    <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md mb-4">
                        {error}
                    </div>
                )}

                {loading ? (
                    <Loader />
                ) : (
                    <DataSettings
                        data={accounts[0]?.attributes}
                        units={units}
                        accountId={accountId}
                        setAttributes={setAttributes}
                    />
                )}
            </div>

            <Modal
                isOpen={isAuditLogModalOpen}
                onClose={() => setIsAuditLogModalOpen(false)}
                modalClass="xl:w-[60%] lg:w-[70%] md:w-[80%] sm:w-[90%] w-[95%]"
            >
                <AuditLogModal
                    isOpen={isAuditLogModalOpen}
                    onClose={() => setIsAuditLogModalOpen(false)}
                    accountId={accountId}
                    linkedType="user"
                    linkedId={accountId}
                />
            </Modal>
        </div>
    );
};

export default Preferences;
